
























import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mixin, Mixins } from 'vue-mixin-decorator'

import LanderMixin from '@/mixins/LanderMixin'; // @ is an alias to /src
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import blog001 from '@/blogs/blog001.vue';             // @ is an alias to /src
import blog002 from '@/blogs/blog002.vue';             // @ is an alias to /src
import blog003 from '@/blogs/blog003.vue';             // @ is an alias to /src

interface fbComment { story_fbid: number, id: number, comment_id: number }

@Component({
  name: 'Blog',
  components: { 
    ModalWrapperComponent: () => import('@/components/ModalWrapperComponent.vue'),
    FBCommentsComponent: () => import('@/components/FBCommentsComponent.vue'),
    LanderStepsComponent: () => import('@/components/LanderStepsComponent.vue'),
    UrgencyAndSignUpButtonComponent: () => import('@/components/UrgencyAndSignUpButtonComponent.vue')
   }
})
export default class BlogView extends Mixins<LanderMixin>(LanderMixin) {

  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }

  public blogId: string = null
  public blogEntryComponent: typeof blog001 | typeof blog002 | typeof blog003 = null
  public dateString: string = null

  public email: string = null

  public userClickedCTA(): void {
    if (this.optimizeForFacebook()) this.userChoseFacebookLogin();
    else this.userChoseRegister()
  }

  public userChoseRegister(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as any).show('Sign Up to StoryCircle', 'sm', null)
  }

  public userChoseFacebookLogin(): void {
    utils_auth.setLocationAfterLogin({ name: "home" });
    (window as any).analytics.track('User ClickedFBLogin')
    this.$fb.login()
  }

  public onOK(): void {
    if (!this.email || this.email.length === 0 || !utils.isValidEmail(this.email)) {
      utils.toast(this, 'Missing field', 'Please enter a valid email address.')
      return
    }
    utils_auth.setLocationAfterLogin({ name: "home" });
    (this.$refs.RegisterFormModalComponent as any).show('Sign Up', 'sm', { email: this.email })
  }

  // lifecycle hooks
  public created() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} created()`)
    this.setStuffFromPath()
  }

  public mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private setStuffFromPath() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} setStuffFromPath()`, this.utm_source, this.utm_campaign, this.utm_medium, this.utm_content)

    this.blogId = this.$route.params.id;
    const passedInTitle: string = this.$route.query.t as string;  // not using this in the wild, but we could
    
    switch (this.blogId) {
      case '10253':
        this.title = passedInTitle || 'From Skeptic to Convert — Sharing My Memories Felt Good!';
        this.dateString = 'January 22, 2020';
        this.blogEntryComponent = blog001;
        this.signUpText = '3 Easy Steps to Preserve Your Memories',
        this.stepsType = 'simpleStoryteller'
        this.image = 'family-daughter-laptop-964x450-50.jpg'
        if (this.utm_content && this.utm_content.includes('pretty-woman-older-dad')) this.image = 'pretty-woman-older-dad-974x450-50.jpg'
        this.buttonCTA = 'Sign Up Now'
        this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'
        break;
      case '11785':
        this.title = passedInTitle || 'Realizing That My Parents Want to Share and Tell Their Stories!';
        this.dateString = 'January 22, 2020';
        this.blogEntryComponent = blog002;
        this.signUpText = 'Don’t let another minute pass - 3 easy steps to help tell a parent’s story.'
        this.stepsType = 'simpleChampion'
        this.image = 'father-son-1000x462-50.jpg'
        this.buttonCTA = 'Sign Up Now'
        this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'
        break;
      case '12890':
        this.title = passedInTitle || 'Why Family Storytelling is Good For You (and Your Children)';
        this.dateString = 'January 22, 2020';
        this.blogEntryComponent = blog003;
        this.signUpText = '3 Easy Steps to Family Storytelling',
        this.stepsType = 'simpleStoryteller'
        this.image = 'grandparents-laughing-with-grandchildren-1000x489-50.jpg'
        this.buttonCTA = 'Sign Up Now'
        this.urgencyText = '<b>Free spaces are limited</b> so please sign up now.'
        break;
      default: this.title = null
    }

    // switch image based on what ad showed
    this.setImageBasedOnUTMContent();

    // for funnel conversion tracking
    (window as any).analytics.track('Blog Viewed', { blogId: this.blogId, title: this.title, image: this.image, buttonCTA: this.buttonCTA, showFbComments: this.showFbComments, showFBLogin: this.$fb.useFbLoginRandomAB });

  }

  // this is necessary because path changes don't reload the component nor its subcomponents
  @Watch('$route.path')
  private pathChanged() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} pathChanged()`)
    this.setStuffFromPath()
  }


}

